import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import AdminCompanyManager from "../components/AdminCompanyManager";
import * as adminActions from "../../../../actions/admin.actions";
import * as userActions from "../../../../actions/user.actions";

class AdminCompanyManagerContainer extends Component {
  constructor(props) {
    super(props);

    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    this.props.adminActions.getUser(this.props.match.params.userId);
    this.props.userActions.getEmailTypes();
    this.props.userActions.getEmailTypesOptions();
  }

  handleSubmit(data) {
    if (data.id) {
      const types = this.props.types;

      if (types.length > 0) {
        let preferences = {};

        types.forEach(function(type) {
          if (data[type.slug]) {
            const value = { [`${type.slug}`]: data[type.slug] };
            preferences = { ...preferences, ...value };
          }
        });

        data.email_preferences = preferences;
      }

      const url = this.props.history.goBack();
      this.props.userActions.updateUserData(data, url, "basicsForm");
    }
  }

  render() {
    return (
      <AdminCompanyManager
        options={this.props.options}
        types={this.props.types}
        user={this.props.user}
        onSubmit={this.handleSubmit}
      />
    );
  }
}

const mapStateToProps = state => {
  return {
    user: state.admin.user,
    options: state.user.email.options,
    types: state.user.email.types
  };
};

const mapDispatchToProps = dispatch => ({
  adminActions: bindActionCreators(adminActions, dispatch),
  userActions: bindActionCreators(userActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AdminCompanyManagerContainer);



// WEBPACK FOOTER //
// ./src/routes/admin/company/containers/AdminCompanyManagerContainer.js